import {
    Directive,
    ElementRef,
    EventEmitter,
    HostBinding,
    HostListener,
    Output,
} from "@angular/core"

@Directive({ selector: "[mobileContextSheetDrag]" })
export class MobileContextSheetDragDirective {
    @Output() mobileContextSheetDismiss = new EventEmitter<void>()

    @HostBinding("class.mobile-context-sheet-dragging") dragging = false
    @HostBinding("style.--mobile-sheet-drag-y.px") dragOffset = 0

    private pointerId: number | null = null
    private startY = 0
    private startTime = 0

    constructor(private element: ElementRef<HTMLElement>) {}

    @HostListener("pointerdown", ["$event"])
    onPointerDown(event: PointerEvent): void {
        const target = event.target as HTMLElement

        if (!target.closest(".mobile-context-sheet-handle")) {
            return
        }

        this.pointerId = event.pointerId
        this.startY = event.clientY
        this.startTime = performance.now()
        this.dragOffset = 0
        this.dragging = true
        this.element.nativeElement.setPointerCapture?.(event.pointerId)
        event.preventDefault()
    }

    @HostListener("pointermove", ["$event"])
    onPointerMove(event: PointerEvent): void {
        if (!this.dragging || this.pointerId !== event.pointerId) {
            return
        }

        this.dragOffset = Math.max(0, event.clientY - this.startY)
        event.preventDefault()
    }

    @HostListener("pointerup", ["$event"])
    onPointerUp(event: PointerEvent): void {
        if (!this.dragging || this.pointerId !== event.pointerId) {
            return
        }

        const elapsed = Math.max(1, performance.now() - this.startTime)
        const velocity = this.dragOffset / elapsed
        const threshold = this.element.nativeElement.offsetHeight * 0.25
        const shouldDismiss = this.dragOffset >= threshold || velocity >= 0.75

        this.element.nativeElement.releasePointerCapture?.(event.pointerId)
        this.dragging = false
        this.pointerId = null

        if (shouldDismiss) {
            this.mobileContextSheetDismiss.emit()
            return
        }

        this.dragOffset = 0
    }

    @HostListener("pointercancel", ["$event"])
    onPointerCancel(event: PointerEvent): void {
        if (this.pointerId !== event.pointerId) {
            return
        }

        this.element.nativeElement.releasePointerCapture?.(event.pointerId)
        this.dragging = false
        this.dragOffset = 0
        this.pointerId = null
    }
}
